import { render } from "./CitiesApportion.vue?vue&type=template&id=96f0dab0&scoped=true"
import script from "./CitiesApportion.vue?vue&type=script&lang=js"
export * from "./CitiesApportion.vue?vue&type=script&lang=js"

import "./CitiesApportion.vue?vue&type=style&index=0&id=96f0dab0&scoped=true&lang=css"
import "./CitiesApportion.vue?vue&type=style&index=1&id=96f0dab0&lang=scss"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f0dab0"]])

export default __exports__